import { Styles } from "../../config"

let devBorder = ""
if (false) devBorder = "1px solid gray"

const styles = {
	container({ isLastEntry }) {
		let marginBottom = "25px"
		if (isLastEntry) marginBottom = "0px"

		return {
			border: devBorder,

			width: "100%",
			maxWidth: "950px",
			marginBottom,
			padding: "25px",
			justifyContent: "center",
			alignItems: "center",

			"@media (max-width: 975px)": {
				padding: "15px"
			},

			"@media (max-width: 800px)": {
				padding: "10px"
			}
		}
	},

	headerContainer: {
		border: devBorder,

		width: "100%",
		marginBottom: "5px"
	},

	header: {
		border: devBorder,

		marginRight: "5px",
		fontSize: Styles.FontSize.t5.size,
		fontWeight: Styles.FontSize.t4.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t6.size
		}
	},

	subheaderContainer: {
		border: devBorder,

		width: "100%",
		marginBottom: "25px",
		alignItems: "center",

		"@media (max-width: 975px)": {
			marginBottom: "15px"
		},

		"@media (max-width: 800px)": {
			alignItems: "flex-start"
		}
	},

	subheader: {
		border: devBorder,

		marginRight: "10px",
		fontSize: Styles.FontSize.t6.size,
		fontWeight: Styles.FontSize.t6.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			fontSize: Styles.FontSize.t7.size
		}
	},

	timelineContainer({ isLastEntry }) {
		let marginBottom = "10px"
		if (isLastEntry) marginBottom = "0px"

		return {
			border: devBorder,

			marginBottom,
			padding: "20px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",

			"@media (max-width: 975px)": {
				padding: "10px"
			},

			"@media (max-width: 800px)": {
				padding: "5px"
			},

			"@media (max-width: 600px)": {
				flexDirection: "column",
				alignItems: "flex-start"
			}
		}
	},

	allocation: {
		border: devBorder,

		minWidth: "100px",
		fontSize: Styles.FontSize.t4.size,
		fontWeight: Styles.FontSize.t5.weight,
		color: Styles.Color.primary,

		"@media (max-width: 975px)": {
			minWidth: "75px",
			fontSize: Styles.FontSize.t6.size,
			fontWeight: Styles.FontSize.t4.weight
		},

		"@media (max-width: 600px)": {
			marginBottom: "10px"
		}
	}
}

export default styles
